<template>
  <div>
    <v-timeline dense align-top>
      <v-timeline-item v-for="(step, i) in steps" :key="i" :color="highlight ? 'primary' : 'secondary'" :icon="step.icon" fill-dot>
        <v-card flat class="pa-0">
          <span class="d-block body-1 font-weight-medium text--secondary">{{ step.title }}</span>
          <span class="d-block body-2 text--primary" v-if="step.description">{{ step.description }}</span>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
export default {
  name: 'VistaFlowDiagram',
  props: {
    steps: {
      type: Array,
      required: true
    },
    highlight: {
      type: Boolean,
      default: false
    }
  }
}
</script>
